<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "NoAccess"
})
</script>

<template>
  <main class="min-h-screen w-full flex items-center justify-center bg-gray-100">
    <div class="bg-white shadow-lg rounded-xl p-8 max-w-lg text-center text-lg">
      <!--
      <h1 class="text-2xl font-bold mb-4">Liebes Eichhorn-Frankfurt-Team</h1>
      <p class="mb-4">
        Leider ist Ihnen der Zugriff auf einen Teil unseres Softwareangebotes ab sofort nicht mehr gestattet.
        Um eine reibungslose Fortsetzung Ihrer Arbeit zu ermöglichen, gewähren wir Ihnen derzeit jedoch noch den Zugriff auf unsere älteren Softwareangebote.
      </p>
      <p>Hier finden Sie den Link zur entsprechenden Trader-Version:</p>
      -->
      <p>Hier finden Sie den Link zum Trader:</p>
      <a href="http://lardilla.zvni.com/" class="text-blue-600 underline">
        http://lardilla.zvni.com/
      </a>
    </div>
  </main>
</template>

<style scoped>
/* Einfach gehalten, aber optisch etwas abgesetzt */
</style>
